import * as React from 'react'

export function useIsMounted(initial = false) {
  const [mounted, setMounted] = React.useState(initial)

  React.useEffect(() => {
    setMounted(true)
  }, [])

  return mounted
}
